import { MAX_FILE_SIZE } from 'Constants';

/**
 * FIle size validation
 *
 * @param {any} value
 */
export function maxFileSizeValidation(value) {
    return !value || (value.size/1024/1024 < MAX_FILE_SIZE) ? '' : ['validation.error.max_size', { max: MAX_FILE_SIZE }];
}



// WEBPACK FOOTER //
// ./src/utils/maxFileSizeValidation.js